module.exports = __webpack_public_path__ + "img/shogi_2021_pack_2_0005.64ceb801.png";